export default "__VITE_ASSET__BuYm7fdk__"